import React, { useEffect, useState } from "react";
import "./Contact.css";

const API =
  process.env.REACT_APP_API_URL || "https://backend-9i6n.onrender.com";

const ACCENTS = [
  { accent: "#0F5C2E", tint: "#E8F3EA" },
  { accent: "#1466A8", tint: "#E7F0F8" },
  { accent: "#C06A12", tint: "#FBF0E0" },
  { accent: "#B23A55", tint: "#F8E9EC" },
];
const FALLBACK = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

const Contact = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      try {
        const res = await fetch(`${API}/api/contacts`);
        const text = await res.text();
        if (text.startsWith("<")) throw new Error("HTML");
        const data = JSON.parse(text);
        setMembers(Array.isArray(data) ? data : []);
      } catch {
        setError("संपर्क माहिती लोड करता आली नाही");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div>
      <section className="rk-hero">
        <div className="rk-hero-inner">
          <div className="rk-crumb">मुख्यपृष्ठ / सदस्य</div>
          <h1 className="rk-hero-title">ग्रामपंचायत सदस्य</h1>
          <p className="rk-hero-sub">लोकनियुक्त प्रतिनिधी व प्रशासकीय अधिकारी — आपल्या सेवेसाठी.</p>
        </div>
      </section>

      <section className="rk-wrap" style={{ paddingBottom: 20 }}>
        {loading ? (
          <p className="rk-loading">संपर्क माहिती लोड होत आहे...</p>
        ) : error ? (
          <p className="rk-error">⚠️ {error}</p>
        ) : members.length === 0 ? (
          <p className="rk-empty">कोणतीही संपर्क माहिती उपलब्ध नाही</p>
        ) : (
          <div className="rk-cols rk-cols-4">
            {members.map((m, i) => {
              const a = ACCENTS[i % ACCENTS.length];
              const img = m.photo && m.photo.startsWith("http") ? m.photo : FALLBACK;
              return (
                <div key={m._id} className="rk-card rk-member">
                  <div className="rk-member-ring" style={{ background: `linear-gradient(135deg,${a.accent},#8ab99a)` }}>
                    <img src={img} alt={m.name} loading="lazy" onError={(e) => { e.target.src = FALLBACK; }} />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 17, marginTop: 14, color: "#17241C" }}>{m.name}</div>
                  <div style={{ fontSize: 13.5, fontWeight: 600, color: a.accent, background: a.tint, display: "inline-block", padding: "3px 14px", borderRadius: 100, marginTop: 6 }}>{m.role}</div>
                  {m.phone && (
                    <div className="rk-member-phone">
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                      {m.phone}
                    </div>
                  )}
                  
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default Contact;
